import { Typography } from "@mui/material";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import NewLink from "../Link/NewLink.tsx";

const footerLinkSx = { display: "inline-block", py: 1.5, textDecoration: "none" };

export default function Footer() {
  return (
    <>
      {
        <Box component="footer" sx={{ py: 6 }}>
          <Container maxWidth="lg">
            <Typography variant="body2" color="textSecondary" align="center">
              © {new Date().getFullYear()} GeoStrat
            </Typography>
            <Typography variant="body2" color="textSecondary" align="center">
              {/* padding brings the tap target to ~44px on touch screens */}
              <NewLink href="/privacy-policy" color="inherit" sx={footerLinkSx}>
                Privacy Policy
              </NewLink>
              {" | "}
              <NewLink href="/terms-of-service" color="inherit" sx={footerLinkSx}>
                Terms of Service
              </NewLink>
            </Typography>
          </Container>
        </Box>
      }
    </>
  );
}
